import { createContext } from 'react';

const UploadedFileContext = createContext(null);

export { UploadedFileContext };
